export function validFloat(field) {
    return !isNaN(parseFloat(field.value)) && isFinite(field.value)
        ? true
        : false;
}
